import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "32.5 32.5 167.5 167.5",
  style: {"enable-background":"new 32.5 32.5 167.5 167.5"},
  "xml:space": "preserve"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  d: "M199 116.5c0 45.9-37.2 83-83 83s-83-37.2-83-83c0-45.9 37.2-83 83-83s83 37.2 83 83",
  style: {"fill":"#fff"}
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("path", {
  d: "M121 82.1c-.9-2.4-3.3-4-5.9-4H105l-26 66.1h12.7l4.9-12.7h31.3l4.8 12.7h12.7L121 82.1zm-21.1 39.2 12.4-33.4 12.4 33.4H99.9z",
  style: {"fill":"#8a8a8c"}
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("path", {
  d: "M157.7 130c6.5-2.3 12.8 4.1 10.6 10.6-.8 2.4-2.7 4.3-5.1 5.1-6.5 2.3-12.9-4.1-10.6-10.6.8-2.4 2.8-4.3 5.1-5.1",
  style: {"fill":"#ff6559"}
}, null, -1)

export function render(_ctx, _cache) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4
  ]))
}
export default render